module.exports = __webpack_public_path__ + "static/affiliate/affiliate-insurance-372721957995e2961aeb34fd1316ec06.webp";